import { useMemo } from "react";

import { useCampaignBudgetMinimums } from "@/features/campaigns/jobboards/api/useCampaignBudgetMinimums";
import CampaignJobBoardMonthsGrid from "@/features/campaigns/jobboards/components/CampaignJobBoardMonthList/CampaignJobBoardMonthList";
import { JobboardCampaignType } from "@/types/response/CampaignJobBoardMonthType";

interface CampaignJobBoardMonthsSectionProps {
  months?: JobboardCampaignType[];
  campaignId: string;
  clientIntegrationModuleId: string;
  clientId: string;
  startDate?: string;
}

function CampaignJobBoardMonthsSection({
  months,
  campaignId,
  clientIntegrationModuleId,
  clientId,
  startDate,
}: CampaignJobBoardMonthsSectionProps) {
  const { data: minimums } = useCampaignBudgetMinimums({
    campaignId,
    clientIntegrationModuleId,
  });

  const effectiveMinimum = useMemo(() => {
    if (!minimums) return undefined;
    if (minimums.minimumMonthlyBudget == null && minimums.minimumBudgetPerVacancy == null) return undefined;
    return Math.max(
      minimums.minimumMonthlyBudget ?? 0,
      (minimums.minimumBudgetPerVacancy ?? 0) * minimums.vacancyCount,
    );
  }, [minimums]);

  return (
    <section className="flex flex-col gap-3 lg:gap-4">
      <CampaignJobBoardMonthsGrid
        months={months}
        campaignId={campaignId}
        clientIntegrationModuleId={clientIntegrationModuleId}
        clientId={clientId}
        minimumBudget={effectiveMinimum}
        vacancyCount={minimums?.vacancyCount}
        startDate={startDate}
      />
    </section>
  );
}

export default CampaignJobBoardMonthsSection;
